import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { type FC, type ReactNode } from "react";
import * as styles from "./styles.css";

type Props = {
  rank: "gold" | "silver" | "bronze" | "selected";
  children: ReactNode;
};

export const AwardsLabel: FC<Props> = ({ rank, children }) => {
  return (
    <span className={styles.label({ rank })}>
      <span className={styles.imageOuter}>
        <LazyLoadImage
          src={`/images/user_frontend/global/icon/icn_awards_${rank}.svg`}
          width={13}
          height={13}
          alt=""
        />
      </span>
      {children}
    </span>
  );
};
